/** localStorage keys for AI-toolkit selections that must survive a page
 * reload (WorkspaceToolkitService) but also must NOT survive a logout on a
 * shared/lab computer (AuthService). Pulled out of workspace-toolkit.service.ts
 * into their own dependency-free module so AuthService — which is loaded
 * eagerly in the main bundle — can clear them on logout without statically
 * importing (and thereby eagerly bundling) that much larger, icon-heavy
 * service. */
export const DISCIPLINE_TAB_STORAGE_KEY = 'vcoe.activeDisciplineTab';
export const DEFAULT_DISCIPLINE_TAB = 'Engineering & IT';
export const SELECTED_DOMAINS_STORAGE_KEY = 'vcoe.selectedDomainIds';
